export default {"src":"/_next/static/media/google.2ad61a47.svg","height":31,"width":30};